const staticPath = process.env.STATIC_PATH || '/'

function pathJoin(...parts) {
  return parts.join('/').replace('//', '/')
}

export default Object.freeze({
  GLOBAL_STYLE_URL: pathJoin(staticPath, 'css/bulmaced.css'),
})
